"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingService = void 0;
const mappers_1 = require("../mappers");
class MappingService {
    constructor() {
        this.assetFoldersMapper = mappers_1.assetFolderMapper;
        this.assetsMapper = mappers_1.assetsMapper;
        this.contentItemsMapper = mappers_1.contentItemsMapper;
        this.contentTypeMapper = mappers_1.contentTypeMapper;
        this.contentTypeSnippetMapper = mappers_1.contentTypeSnippetMapper;
        this.elementsMapper = mappers_1.elementsMapper;
        this.languageMapper = mappers_1.languageMapper;
        this.languageVariantMapper = mappers_1.languageVariantMapper;
        this.projectMapper = mappers_1.projectMapper;
        this.taxonomyMapper = mappers_1.taxonomyMappper;
        this.webhookMapper = mappers_1.webhookMapper;
        this.workflowMapper = mappers_1.workflowMapper;
    }
}
exports.MappingService = MappingService;
//# sourceMappingURL=mapping-service.class.js.map